import { MediaQueryAttributeInput } from '@repo/common-utils/mediaQueryAttributeInputHelper';
import { useProduct } from '@repo/widget-utils/services/hooks/product';
import ProductGallery2, {
    ProductGalleryAlign,
} from 'src/widgets/activities/product/product-gallery-2/gallery/ProductGallery2';

export default function ProductGallery2WidgetRoot(props: {
    productCatalogId: string;
    numVisibleImages: MediaQueryAttributeInput;
    align: ProductGalleryAlign;
}) {
    const { data: product } = useProduct(props.productCatalogId);

    return (
        <ProductGallery2
            imageList={product?.images ?? null}
            numVisibleImages={props.numVisibleImages}
            align={props.align}
        />
    );
}
